import { AccrualImporterRow } from "./types";
import {
    AccrualImporterExtractionId,
    createAccrualImporterExtractionId,
} from "./accrualImporterExtractionId";

type CreateAccrualImporterRowParams = {
    _id: string;
    extractionId?: AccrualImporterExtractionId;
} & Partial<Omit<AccrualImporterRow, "_id" | "extractionId">>;

export function createAccrualImporterRow({
    _id,
    extractionId = createAccrualImporterExtractionId(),
    accrualId = undefined,
    lineId = undefined,
    createdDate = "",
    counterpartyId = null,
    invoiceNumber = "",
    memo = "",
    productOrService = "",
    catalogItemId = null,
    catalogItemPriceId = null,
    description = "",
    classIds = null,
    quantity = null,
    unitPrice = null,
    amount = null,
    dueDate = "",
    accrualLedger = "",
    accrualAccountId = "",
    entityId = null,
    financialAccountId = null,
    totalAmount = null,
    tax = undefined,
    ...overrides
}: CreateAccrualImporterRowParams): AccrualImporterRow {
    return {
        _id,
        extractionId,
        accrualId,
        lineId,
        createdDate,
        counterpartyId,
        invoiceNumber,
        memo,
        productOrService,
        catalogItemId,
        catalogItemPriceId,
        description,
        classIds,
        quantity,
        unitPrice,
        amount,
        dueDate,
        accrualLedger,
        accrualAccountId,
        entityId,
        financialAccountId,
        totalAmount,
        tax,
        ...overrides,
    };
}
